import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input} from '@angular/core';
import {VisitOverviewServiceStatusComponent} from "../visit-overview-service-status.component";
import {DeclarationType, TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";
import {DeclarationMessageStatus, VisitOverviewUtils} from "../../visit-overview.utils";
import {PortVisitCommonModule} from "../../../../../common/port-visit-common.module";

@Component({
  selector: 'app-stevedore-visit-overview-service-status',
  imports: [
    PortVisitCommonModule
  ],
  templateUrl: './stevedore-visit-overview-service-status.component.html',
  styleUrls: ['./stevedore-visit-overview-service-status.component.scss', '../visit-overview-service-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StevedoreVisitOverviewServiceStatusComponent extends VisitOverviewServiceStatusComponent {
  private cdr = inject(ChangeDetectorRef);
  _declarationTypes = [DeclarationType.TERMINAL_PLANNING];
  terminalMessageStatuses: DeclarationMessageStatus[] = [];
  cargoHandlingStatus: DeclarationMessageStatus;
  _serviceStatusButtonId: string;
  _serviceStatusSpanId: string;

  updateMessageStatus() {
    this.cargoHandlingStatus = VisitOverviewUtils.getCargoHandlingStatus(this._summary);
    this.terminalMessageStatuses = VisitOverviewUtils.getTaskStatuses(this._summary, this._declarationTypes, this.clearanceService)
      .map(t => ({
        ...t,
        customLabel: t.customLabel || this.messageStatusLabel(t)
      }));
    this.messageStatus = VisitOverviewUtils.getLeastTaskMessageStatus(this.terminalMessageStatuses.concat(this.cargoHandlingStatus));
  }

  @Input()
  set serviceStatusButtonId(serviceStatusButtonId: string) {
    this._serviceStatusButtonId = serviceStatusButtonId;
  }

  @Input()
  set serviceStatusSpanId(serviceStatusSpanId: string) {
    this._serviceStatusSpanId = serviceStatusSpanId;
  }

  hoverServiceStatusSpan(serviceStatusSpanId: string, hover: boolean): void {
    const style = document.getElementById(serviceStatusSpanId).style;

    if (!!style) {
      if (hover) {
        style.textDecoration = 'underline';
      } else {
        style.textDecoration = 'none';
      }
    }
  }

  messageStatusLabel = (status: DeclarationMessageStatus): string => {
    if (status.customLabel) {
      return status.customLabel;
    }
    switch (status.taskStatus) {
      case TaskMessageStatus.UNKNOWN:
        return "Nothing filled in";
      case TaskMessageStatus.SAVED:
        return "(Partly) filled but not sent";
      case TaskMessageStatus.DEADLINE_CLOSE:
        return "Deadline in X days";
      case TaskMessageStatus.DEADLINE_MISSED:
        return "Deadline missed";
      case TaskMessageStatus.PENDING:
        return "Pending";
      case TaskMessageStatus.DELIVERED:
        return "Received";
      case TaskMessageStatus.ACCEPTED:
        return "Approved";
      case TaskMessageStatus.ACCEPTED_WITH_CONDITIONS:
        return "Accepted with conditions";
      case TaskMessageStatus.WARNING:
        return status.reason || "Rescheduled";
      case TaskMessageStatus.ERROR:
        return status.reason || "Error";
      case TaskMessageStatus.REJECTED:
        return "Rejected";
    }
    return null;
  };
}
